import cx from "classnames";
import type { FC } from "react";

import { HttpIcon, PostgresIcon } from "@moment/icons";
import { Chip } from "@moment/ui";

import {
	LogoAWS,
	LogoArgoCD,
	LogoBrex,
	LogoDatadog,
	LogoFallback,
	LogoGithub,
	LogoGreenhouse,
	LogoInfracost,
	LogoKubernetes,
	LogoLinear,
	LogoMoment,
	LogoNotion,
	LogoOpenAI,
	LogoPagerduty,
	LogoVercel,
} from "../icons";

export const ATLAS_NAME_ICON_MAP = {
	"argocd": { Icon: LogoArgoCD, name: "ArgoCD" },
	"aws": { Icon: LogoAWS, name: "AWS" },
	"brex": { Icon: LogoBrex, name: "Brex" },
	"datadog": { Icon: LogoDatadog, name: "Datadog" },
	"echo": { Icon: LogoFallback, name: "Echo" },
	"github": { Icon: LogoGithub, name: "GitHub" },
	"github-ecs": { Icon: LogoGithub, name: "GitHub ECS" },
	"github-dynamic": { Icon: LogoGithub, name: "GitHub Dynamic" },
	"greenhouse": { Icon: LogoGreenhouse, name: "Greenhouse" },
	"infracost": { Icon: LogoInfracost, name: "Infracost" },
	"infracost-pg": { Icon: LogoInfracost, name: "Infracost PG" },
	"infracost-pg-2": { Icon: LogoInfracost, name: "Infracost PG2" },
	"kubernetes": { Icon: LogoKubernetes, name: "Kubernetes" },
	"linear": { Icon: LogoLinear, name: "Linear" },
	"moment": { Icon: LogoMoment, name: "Moment" },
	"notion": { Icon: LogoNotion, name: "Notion" },
	"openai": { Icon: LogoOpenAI, name: "OpenAI" },
	"pagerduty": { Icon: LogoPagerduty, name: "PagerDuty" },
	"postgres": { Icon: PostgresIcon, name: "Postgres" },
	"vercel": { Icon: LogoVercel, name: "Vercel" },
	"http": { Icon: HttpIcon, name: "Custom HTTP Adapter" },
} as const;

const getMappedAdapter = (name: string) => {
	const key = name.toLowerCase() as keyof typeof ATLAS_NAME_ICON_MAP;
	const mapped = ATLAS_NAME_ICON_MAP[key];

	return mapped;
};

export const getAdapterIcon = (name?: string) => {
	if (name === undefined) {
		return LogoFallback;
	}

	const mapped = getMappedAdapter(name);
	return mapped?.Icon ?? LogoFallback;
};

export const getAdapterName = (name: string) => {
	const mapped = getMappedAdapter(name);
	return mapped?.name ?? name;
};

export const AtlasAdapterNameIcon: FC<{
	variant?: "default" | "negative";
	name?: string;
	badge?: string;
}> = ({ variant = "default", name, badge }) => {
	const Icon = getAdapterIcon(name);
	const nameWithFallback = name ? getAdapterName(name) : "unknown";
	return (
		<div className="flex items-center space-x-2">
			<Icon
				className={cx("shrink-0 ", {
					"fill-icon-negative-default": variant === "negative",
					"fill-icon-default": variant !== "negative",
				})}
			/>
			<div>{nameWithFallback}</div>
			{badge !== "" && <Chip size="sm">{badge}</Chip>}
		</div>
	);
};
